import { apiWrapper } from 'ccs-ui-components';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IServiceResponseModel } from '../../../models';
import { serviceListResponseSchema } from '../../../utilities/sources/RegistriesSchemaDefintion';

/**
 * Custom hook to call schema api
 * @returns promise
 */
const useService = () => {
  async function callSearchService(sName: string, sStatus: string[], exactNameMatch: boolean) {
    const requestBody = {
      services: [{
        serviceName: sName
      }],
      exactNameMatch,
      status: sStatus,
    };

    const resp = await apiWrapper.post<IServiceResponseModel, { errorMessage: string }>(
      `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/services/search`,
      requestBody,
      headersInstance()
    );

    const apiResponse = serviceListResponseSchema.validate(resp.responseBody, {
      abortEarly: true
    });

    if (resp.isError || !apiResponse.value) {
      return {
        errorMessage: resp.errorBody?.errorMessage,
        isError: resp.isError,
        statusCode: resp.statusCode
      };
    }
    const serviceRecords = resp.responseBody;
    return {
      serviceRecords,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }

  const searchServiceByName = (sName: string, status: string[], exactNameMatch: boolean) => callSearchService(sName, status, exactNameMatch);
  return { searchServiceByName };
};

export default useService;
